import privacyPolicy from "../../../legal/privacy-policy.md?raw";
import termsOfService from "../../../legal/terms-of-service.md?raw";
import { renderMarkdown } from "../../../legal/markdown.mjs";
import { fillOperator, type LegalDoc } from "@shared/legal";

const SOURCES: Record<LegalDoc, string> = { privacy: privacyPolicy, terms: termsOfService };

/** A legal document as HTML, with the operator's details filled in. */
export function legalHtml(doc: LegalDoc): string {
  return renderMarkdown(fillOperator(SOURCES[doc]));
}
